import { connect } from "react-redux";

import * as actions from "./account.balance.actions";
import * as transactionActions from "../../transactions/actions";

import moment from "moment";

function mapStateToProps(state) {
  return {
    accountBalance: state.accountBalance,
    transactions: state.transactions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchTrustlyAccountBalance: (currency) => {
      dispatch(actions.fetch_trustly_account_balance(currency));
    },

    fetchAccountBalanceForDay: (date, currency) => {
      dispatch(actions.fetch_account_balance_for_day(date, currency));
    },

    fetchLsAccountBalances: (date, currency) => {
      dispatch(actions.fetch_ls_account_balances(date, currency));
    },

    fetchOriginatorBalances: (date, currency) => {
      dispatch(actions.fetch_originator_balances(date, currency));
    },

    fetchAccountBalanceForTimeSpan: (from, to, currency) => {
      dispatch(actions.fetch_account_balance_for_time_span(from, to, currency));
    },

    fetchTransactionsForTimeSpan: (from, to, currency) => {
      from = moment(from).format("YYYY-MM-DD");
      to = moment(to).format("YYYY-MM-DD");

      //Those two lines would not be necessary when we completly ditch the transactions view
      dispatch(
        transactionActions.change_transaction_list_filter_date(
          "from",
          new Date(from),
        ),
      );
      dispatch(
        transactionActions.change_transaction_list_filter_date(
          "to",
          new Date(to),
        ),
      );

      dispatch(transactionActions.get_transactions(from, to, currency));
    },

    fetchTransactionsForDay: (day, currency) => {
      //TODO create a different method, this thing should be temporary
      let from = moment(day).format("YYYY-MM-DD");
      let to = moment(day).add(1, "day").format("YYYY-MM-DD");

      //Those two lines would not be necessary when we completly ditch the transactions view
      dispatch(
        transactionActions.change_transaction_list_filter_date(
          "from",
          new Date(from),
        ),
      );
      dispatch(
        transactionActions.change_transaction_list_filter_date(
          "to",
          new Date(to),
        ),
      );

      dispatch(transactionActions.get_transactions(from, to, currency));
    },

    changeDate: (dateType, date) => {
      dispatch(actions.change_date(dateType, date));
    },
  };
}

export const accountBalanceConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
